import React from "react";
import ReactMarkdown from "react-markdown";
import remarkHtml from "remark-html";
import styled from "styled-components";
import { Link } from "react-router-dom";

const StyledHeading = styled.h1`
  font-size: ${({ level }) => {
    switch (level) {
      case "h1":
        return "1.4em";
      case "h2":
        return "1.4em";
      case "h3":
        return "1em";
      default:
        return "0.9em";
    }
  }};
  margin-top: ${({ level }) => (level === "h3" ? "0.25em" : "1em")};
  margin-bottom: 0.5em;
  color: #333;
`;

const StyledParagraph = styled.p`
  font-size: 14px;
  line-height: 1.6;
  color: #555;
  margin-bottom: 0.25rem;
`;

const MarkdownParser = ({ markdown }) => {
  const LinkRenderer = ({ href, children }) => (
    <Link
      to={href}
      className="px-1 text-[#555] rounded-[3px] transition-colors duration-200 ease-in-out hover:bg-primary/20 hover:text-primary"
    >
      {children}
    </Link>
  );

  const HeadingRenderer = (props) => {
    return (
      <h3 style={{ fontSize: 18 }}>{props.children}</h3>
    );
  };

  const ParagraphRenderer = ({ children }) => (
    <StyledParagraph>{children}</StyledParagraph>
  );

  return (
    <ReactMarkdown
      children={markdown}
      remarkPlugins={[remarkHtml]}
      components={{
        h1: HeadingRenderer,
        h2: HeadingRenderer,
        h3: HeadingRenderer,
        h4: HeadingRenderer,
        h5: HeadingRenderer,
        h6: HeadingRenderer,
        p: ParagraphRenderer,
        a: LinkRenderer,
      }}
    />
  );
};

export default MarkdownParser;
